import * as classNames from 'classnames';
import { ERPGIcon } from 'motw_core/UI/Icons/ERPGIcon';
import * as React from 'react';
import Hyperlink, { THyperlinkHandler } from '../../../presentation/Shared/Link/Hyperlink';
import RPGIcon from '../../../presentation/Shared/RPGIcon/RPGIcon';
import * as styles from './RPGIconWithText.css';

export function RPGIconWithText({
	whenClicked,
	icon,
	withClass,
	children
}: {
	whenClicked: THyperlinkHandler;
	icon: ERPGIcon;
	withClass?: string;
	children?: any;
}) {
	return (
		<Hyperlink whenClicked={whenClicked}>
			<span className={classNames(withClass)}>
				<RPGIcon icon={icon} withClass={styles.icon} />
				{children}
			</span>
		</Hyperlink>
	);
}
